import { types } from 'mobx-state-tree';
import { NAV_COLLAPSED_WIDTH } from '@routific/hive/v5';

const MAIN_MENU_DEFAULT_EXPANDED_WIDTH = 280;
// Must equal Hive's token; a different value offsets the centered nav icons.
const MAIN_MENU_DEFAULT_COLLAPSED_WIDTH = NAV_COLLAPSED_WIDTH;

const MenuContainer = types
  .model('MenuContainer', {
    isExpanded: types.boolean,
  })
  .actions((self) => ({
    loadLocalStorageState() {
      const storedValue = localStorage.getItem('menuIsExpanded');
      self.isExpanded = storedValue ? storedValue === 'true' : false;
    },
    expand() {
      self.isExpanded = true;
      localStorage.setItem('menuIsExpanded', 'true');
    },
    collapse() {
      self.isExpanded = false;
      localStorage.setItem('menuIsExpanded', 'false');
    },
    toggle() {
      const newExpandedState = !self.isExpanded;
      self.isExpanded = newExpandedState;
      localStorage.setItem('menuIsExpanded', String(newExpandedState));
    },
    setResponsiveExpanded(expanded: boolean) {
      self.isExpanded = expanded;
    },
  }))
  .views((self) => ({
    get width() {
      return self.isExpanded ? MAIN_MENU_DEFAULT_EXPANDED_WIDTH : MAIN_MENU_DEFAULT_COLLAPSED_WIDTH;
    },
  }))
  .actions((self) => ({
    afterCreate() {
      self.loadLocalStorageState();
    },
  }));

const MainMenuStore = MenuContainer.create({
  isExpanded: true,
});

export default MainMenuStore;
export { MenuContainer, MAIN_MENU_DEFAULT_EXPANDED_WIDTH, MAIN_MENU_DEFAULT_COLLAPSED_WIDTH };
